function Iletisim() {
  return (
    <div>
      <h1>İletişim</h1>
      <p>Aliquam veritatis unde, quod facere voluptatibus quisquam quaerat, vitae facilis ullam fuga voluptas quas accusantium nemo sequi cupiditate consectetur quia consequatur cum architecto, voluptate veniam? Fugiat recusandae placeat qui rerum!</p>
    </div>
  )
}

export default Iletisim;